import _ from 'lodash'

window.addEventListener('load', function () {
    /* Back to top
    ---------------------------------------------------------------------------------------------------- */
    let scrollToTop = function (ev) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        })
    }
    const $btnScrollTop = document.querySelectorAll('#back-to-top')

    if ($btnScrollTop.length > 0) {
        for (let bEl of $btnScrollTop) {
            bEl.addEventListener('click', scrollToTop)
        }
    }

    /* Modify products grid
    ---------------------------------------------------------------------------------------------------- */
    if (document.querySelector('body').classList.contains('single-product-catalog')) {
        document.querySelector('.kpc-grid-spaceBetween-middle').className = 'kpc-grid-spaceBetween'
    }

    /* Front Page
    ---------------------------------------------------------------------------------------------------- */
    if (document.querySelector('body').classList.contains('front-page')) {
        if (window.matchMedia('(max-width: 1199px)').matches) {
            document.querySelector('#front-cover').setAttribute('viewBox', '260 -10 1700 850')
        } else {
            document.querySelector('#front-cover').setAttribute('viewBox', '190 60 1850 760')
        }

        window.addEventListener('resize', () => {
            if (window.matchMedia('(max-width: 1199px)').matches) {
                document.querySelector('#front-cover').setAttribute('viewBox', '260 -10 1700 850')
            } else {
                document.querySelector('#front-cover').setAttribute('viewBox', '190 60 1850 760')
            }
        })
    }
})

document.addEventListener('hasCookieConsented', function () {})
